<template>
  <v-container class="tabs-content__container">
    <v-slide-y-transition mode="out-in">
      <v-card text>
        <v-row class="ma-0">
          <v-flex xs12>
            <h1>Landing Pages</h1>
          </v-flex>
          <v-flex xs12>
            <span>Create and edit your landing pages</span>
          </v-flex>
          <v-col cols="12">
            <v-row>
              <v-col cols="4">
                <v-card color="blue-grey darken-2" class="white--text" dark>
                  <v-card-title primary-title>
                    <h3>Endorse</h3>
                    <span>Ask your supporters to endorse you online</span>
                  </v-card-title>
                  <v-card-actions>
                    <v-btn text>Edit</v-btn>
                    <v-spacer />
                    <v-card width="100px" color="transparent" text>
                      <v-switch
                        :label="switchLabel1"
                        v-model="switch1"
                        color="red"
                      />
                    </v-card>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="4">
                <v-card color="blue-grey darken-2" class="white--text" dark>
                  <v-card-title primary-title>
                    <h3>Sign a petition</h3>
                    <span>Ask your supporters to sign a petition</span>
                  </v-card-title>
                  <v-card-actions>
                    <v-btn text>Edit</v-btn>
                    <v-spacer />
                    <v-card width="100px" color="transparent" text>
                      <v-switch
                        :label="switchLabel2"
                        v-model="switch2"
                        color="red"
                      />
                    </v-card>
                  </v-card-actions>
                </v-card>
              </v-col>

              <v-col cols="4">
                <v-card color="blue-grey darken-2" class="white--text" dark>
                  <v-card-title primary-title>
                    <h3>Absentee ballot</h3>
                    <span>Get your supporters to request an absentee ballot</span>
                  </v-card-title>
                  <v-card-actions>
                    <v-btn text>Edit</v-btn>
                    <v-spacer />
                    <v-card width="100px" color="transparent" text>
                      <v-switch
                        :label="switchLabel3"
                        v-model="switch3"
                        color="red"
                      />
                    </v-card>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <!-- <v-flex xs12>
            <audiences-report-table
            :files="files"
            ></audiences-report-table>
          </v-flex> -->
        </v-row>
      </v-card>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
  // import AudiencesReportTable from './AudiencesReportTable.vue'
  export default {
    name: 'landing-pages',
    components: {
      // AudiencesReportTable
    },
    data () {
      return {
        // filesTableActive: true,
        switch1: false,
        switch2: false,
        switch3: false,
        files: [
          {
            id: 1,
            list: 'Prospect donor list Apr 20 - 1',
            uploaded: '2018-04-20',
            status: 'processing',
            size: 'TBD'
          },
          {
            id: 2,
            list: 'Prospect donor list Apr 19 - 2',
            uploaded: '2018-04-19',
            status: 'Too small',
            size: '< 1000'
          },
          {
            id: 3,
            list: 'Prospect donor list Apr 19 - 1',
            uploaded: '2018-04-19',
            status: 'Ready',
            size: '2,025'
          }
        ],
        next: true
      }
    },
    computed: {
      activeComponent () {
        if (this.filesTableActive) return 'files-table'
        return 'stepper'
      },
      switchLabel1 () {
        return (this.switch1 ? 'Live' : 'In draft')
      },
      switchLabel2 () {
        return (this.switch2 ? 'Live' : 'In draft')
      },
      switchLabel3 () {
        return (this.switch3 ? 'Live' : 'In draft')
      }
    },
    methods: {
      addFile (file) {
        this.filesTableActive = true
        Object.assign(file, {id: this.files.length + 1})
        this.files.unshift(file)
      },
      removeFile (id) {
        this.files = this.files.filter(file => file.id !== id)
      }
    }
  }
</script>
<style>
    .component-fade-enter-active, .component-fade-leave-active {
        transition: opacity .3s ease;
    }
    .component-fade-enter, .component-fade-leave-to
        /* .component-fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    .switch label {
      color: white!important
    }
</style>
